// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94a27091","467":"283dd67f","514":"18a118c0"}[chunkId] + ".chunk.js";
};